import styled from 'styled-components'

const H4 = styled.h4`
  font-family: 'Montserrat', sans-serif;
  margin: 0;
  font-size: 1.2em;
`
export default H4
